export default __webpack_public_path__ + "aeb5b450a52c94ce0ea582cfb0bcaa5e.png";